// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { targetCrosshairsProgress16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-target-crosshairs-progress': IconTargetCrosshairsProgress;
    }
}

/**
 * The icon component for the 'targetCrosshairsProgress' icon
 */
export class IconTargetCrosshairsProgress extends IconSvg {
    public constructor() {
        super(targetCrosshairsProgress16X16);
    }
}

registerIconSvg('icon-target-crosshairs-progress', IconTargetCrosshairsProgress);
export const iconTargetCrosshairsProgressTag = 'nimble-icon-target-crosshairs-progress';
